export enum UserType {
  UNKNOWN = 'UNKNOWN',
  STUDENT = 'STUDENT',
  PARENT = 'PARENT',
  TEACHER = 'TEACHER',
  ADMIN = 'ADMIN',
  UPSTART = 'UPSTART',
}

export enum UserRole {
  UPSTART_PARENT = 'upstart-parent',
  CLASS_ADMIN = 'class-admin',
  SCHOOL_ADMIN = 'school-admin',
  DISTRICT_ADMIN = 'district-admin',
  INTERNAL_ADMIN = 'internal-admin',
  CURRICULUM_ADMIN = 'curriculum-admin',
  ACCOUNT_ADMIN = 'account-admin',
  SUPPORT_ENGINEER = 'support-engineer',
  PRODUCT_ADMIN = 'product-admin',
  PLAYLIST_ADMIN = 'playlist-admin',
  ENROLLMENT_SUPPORT = 'enrollment-support',
  PROVIDER_COACH = 'provider-coach',
}

export interface User {
  idToken: string;
  refreshToken?: string;
  name: string;
  cognitoUsername?: string;
  preferredName?: string;
  type: UserType;
  isUpstart: boolean;
  application: string;
  /**
   * @deprecated Use `sub` instead.
   */
  uuid?: string;
  sub?: string;
  organization?: string;
  grade?: number;
  school?: string;
  classroom?: string;
  email?: string;
  cognitoId: string;
  roles?: UserRole[];
  providerName?: string;
  accountType?: string;
  preferredLanguages?: string[];
}

export const UserRolesThatCanAccessAdminAccountsTab: UserRole[] = [
  UserRole.INTERNAL_ADMIN,
  UserRole.ACCOUNT_ADMIN,
  UserRole.SUPPORT_ENGINEER,
  UserRole.PROVIDER_COACH,
];

export function hasAccessToAdminAccountsTab(userRoles: UserRole[]): boolean {
  return userRoles.some((role) => UserRolesThatCanAccessAdminAccountsTab.includes(role));
}

export function nonAdminUserTypes(): UserType[] {
  return Object.values(UserType).filter((userType) => userType !== UserType.ADMIN);
}

export function userRolesThatDoNotHaveAccessToAdminAccountsTab(): UserRole[] {
  return Object.values(UserRole).filter((userRole) => !hasAccessToAdminAccountsTab([userRole]));
}
